import React from "react";
import classes from "./formInput.module.css";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";

export const FormInput = ({
  id,
  label,
  type = "text",
  register,
  validation = {},
  disabled = false,
  readOnly = false, // ✅ NEW
  value,
  onChange,
  error,
  required = false,
}) => {
  
  const inputClass = `
    ${classes.input}
    ${disabled ? classes.disabled : ""}
    ${readOnly ? classes.readOnlyInput : ""}
    ${error ? classes.error : ""}
  `;

  return (
    <div className={classes.wrapper}>
      <div className={classes.inputBox}>
        <input
          id={id}
          type={type}
          disabled={disabled}   // ❌ only if truly disabled
          readOnly={readOnly}   // ✅ correct lock
          className={inputClass}
          {...(register ? register(id, validation) : {})}
          value={register ? undefined : value}
          onChange={register ? undefined : onChange}
          placeholder=" "
        />

        <label htmlFor={id} className={classes.floatingLabel}>
          {label}
          {required && <span className={classes.asterisk}>*</span>}
        </label>

        {error && (
          <div className={classes.errorIcon} title={error}>
            <ExclamationCircleIcon className={classes.icon} />
          </div>
        )}
      </div>
    </div>
  );
};
